import React from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { MainContent } from "../../components/exercises/MainContent";
import { MainList } from "../../components/exercises/MainList";
import { SubList } from "../../components/exercises/SubList";
import { isEmpty } from "../../utils/isEmpty";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ProtocolTreeView } from "../../components/exercises/ProtocolTreeView";

const ExercisePage = () => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const location = useLocation();
  const exerciseData = isEmpty(location.state?.exerciseData)
    ? {}
    : location.state.exerciseData;
  const currentSection = location.pathname.split("/")[4];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        width: "100%",
      }}
    >
      <MainList data={exerciseData} />
      <SubList data={exerciseData} />
      <Box
        display={
          isMobile && (currentSection === null || currentSection === undefined)
            ? "block"
            : "none"
        }
      >
        <ProtocolTreeView />
      </Box>
      <MainContent />
    </Box>
  );
};

export default ExercisePage;
